(function () {
  function initStickyAtc() {
    var bar = document.querySelector('[data-sticky-atc]');
    if (!bar || bar.dataset.stickyInit === '1') return;

    var root =
      document.querySelector('[data-product-root]') ||
      document.querySelector('[data-product-content]') ||
      document;

    var variants = [];
    try {
      variants = JSON.parse(
        bar.querySelector('[data-sticky-atc-variants]').textContent
      );
    } catch (e) { variants = []; }

    var thumbEl = bar.querySelector('[data-sticky-thumb]');
    var fallbackImg = thumbEl ? thumbEl.getAttribute('src') : '';

    // Relocate the bar to the product root (which carries [data-color-scheme]).
    // It is otherwise rendered inside .product-block-area, which is `lg:sticky`
    // and therefore creates its own stacking context — trapping the bar below
    // the header on desktop. The product root does not create a stacking context,
    // so moving here lets z-index sit above the header while keeping every
    // --color-scheme-* / --button-color-* variable inherited.
    var productRoot = document.querySelector('[data-product-root]');
    if (productRoot && bar.parentNode !== productRoot) {
      productRoot.appendChild(bar);
    }

    function q(sel, ctx) { return (ctx || root).querySelector(sel); }
    function qa(sel, ctx) {
      return Array.prototype.slice.call((ctx || bar).querySelectorAll(sel));
    }

    function mainForm() {
      return (
        q('[data-product-content] [data-product-form]') ||
        q('[data-product-form]')
      );
    }
    function mainAddButton() {
      var f = mainForm();
      return f ? f.querySelector('.add-to-cart') : null;
    }
    function picker() {
      return q('[data-variant-picker]');
    }

    function currentVariant() {
      // 1) trust the form's hidden id input
      var f = mainForm();
      var idInput = f ? f.querySelector('input[name="id"]') : null;
      if (idInput && idInput.value) {
        for (var i = 0; i < variants.length; i++) {
          if (variants[i].id === String(idInput.value)) return variants[i];
        }
      }
      // 2) fall back to the checked option radios
      var pk = picker();
      if (pk) {
        var checked = qa('input[data-single-option-selector]:checked', pk);
        if (checked.length) {
          var byPos = {};
          checked.forEach(function (inp) {
            byPos[inp.getAttribute('data-position')] = inp.value;
          });
          for (var j = 0; j < variants.length; j++) {
            var opts = variants[j].options || [];
            var ok = true;
            Object.keys(byPos).forEach(function (pos) {
              if (opts[parseInt(pos, 10) - 1] !== byPos[pos]) ok = false;
            });
            if (ok) return variants[j];
          }
        }
      }
      return null;
    }

    var addTxt =
      (bar.querySelector('[data-sticky-add-label]') || {}).textContent ||
      'Add to cart';
    var soldTxt = 'Sold out';

    // Writes are guarded so they only touch the DOM when a value actually
    // changes. There is deliberately NO MutationObserver here — the sticky bar
    // lives inside the product content, so observing that subtree while writing
    // into it would loop endlessly. Variant changes are caught via the picker's
    // 'change' event and the swatch/add click handlers instead.
    function setText(el, val) {
      if (el && val != null && el.textContent !== val) el.textContent = val;
    }

    function sync() {
      var v = currentVariant();
      var mainBtn = mainAddButton();

      if (v) {
        qa('[data-sticky-price]').forEach(function (el) { setText(el, v.price); });
        var onSale = !!v.on_sale;
        qa('[data-sticky-compare]').forEach(function (el) {
          if (onSale && v.compare_at) {
            setText(el, v.compare_at);
            if (el.hidden) el.hidden = false;
          } else {
            if (!el.hidden) el.hidden = true;
            setText(el, '');
          }
        });
        qa('[data-sticky-priceblock]').forEach(function (el) {
          if (el.classList.contains('is-sale') !== onSale) el.classList.toggle('is-sale', onSale);
        });
        qa('[data-sticky-colour]').forEach(function (el) { setText(el, v.option1); });
        var img = v.image || fallbackImg;
        qa('[data-sticky-thumb]').forEach(function (el) {
          if (img && el.getAttribute('src') !== img) el.setAttribute('src', img);
        });
      }

      var selValue = v ? v.option1 : null;
      if (!selValue) {
        var pk = picker();
        var chk = pk
          ? pk.querySelector('input[data-single-option-selector][data-position="1"]:checked')
          : null;
        if (chk) selValue = chk.value;
      }
      qa('[data-sticky-swatch]').forEach(function (sw) {
        var want = sw.getAttribute('data-value') === selValue;
        if (sw.classList.contains('is-selected') !== want) {
          sw.classList.toggle('is-selected', want);
        }
      });

      var disabled = mainBtn ? mainBtn.disabled : (v ? !v.available : true);
      var soldOut = v ? !v.available : true;
      qa('[data-sticky-add]').forEach(function (btn) {
        if (btn.disabled !== disabled) btn.disabled = disabled;
        if (btn.classList.contains('is-disabled') !== disabled) {
          btn.classList.toggle('is-disabled', disabled);
        }
        setText(btn.querySelector('[data-sticky-add-label]'), soldOut ? soldTxt : addTxt);
      });
    }

    // colour swatch -> click the real radio input (runs the theme's own logic)
    qa('[data-sticky-swatch]').forEach(function (sw) {
      sw.addEventListener('click', function () {
        var name = sw.getAttribute('data-option-name');
        var val = sw.getAttribute('data-value');
        var pk = picker();
        if (!pk) return;
        var target = qa('input[data-single-option-selector]', pk).filter(function (i) {
          return i.getAttribute('name') === 'options[' + name + ']' && i.value === val;
        })[0];
        if (target) {
          target.click();
          setTimeout(sync, 60);
          setTimeout(sync, 300);
          setTimeout(sync, 700);
        }
      });
    });

    // sticky Add to cart -> click the real submit button
    qa('[data-sticky-add]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var mainBtn = mainAddButton();
        if (mainBtn && !mainBtn.disabled) mainBtn.click();
      });
    });

    // Desktop (1024px+, the same breakpoint sticky-atc.css uses): reveal once
    // the main buy-buttons scroll above the top.
    // Mobile: also show before they are reached (below the fold, as the
    // gallery sits above them), so a buy button is always on screen.
    var desktopMq = window.matchMedia('(min-width: 1024px)');
    var visible = false;
    function reveal() {
      var anchor =
        q('[data-product-content] .add-to-cart-container') || mainAddButton();
      if (!anchor) return;
      var rect = anchor.getBoundingClientRect();
      var scrolledPast = rect.bottom <= 8;
      var notReachedYet = rect.top >= window.innerHeight;
      var shouldShow = scrolledPast || (!desktopMq.matches && notReachedYet);
      if (shouldShow !== visible) {
        visible = shouldShow;
        bar.classList.toggle('is-visible', visible);
        bar.setAttribute('aria-hidden', visible ? 'false' : 'true');
      }
    }
    window.addEventListener('scroll', reveal, { passive: true });
    window.addEventListener('resize', reveal);

    // keep in sync when the theme re-renders the variant fragment
    var pk = picker();
    if (pk) {
      pk.addEventListener('change', function () {
        setTimeout(sync, 30);
        setTimeout(sync, 300);
      });
    }

    bar.dataset.stickyInit = '1';
    sync();
    reveal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyAtc);
  } else {
    initStickyAtc();
  }
  document.addEventListener('shopify:section:load', function () {
    var b = document.querySelector('[data-sticky-atc]');
    if (b) b.dataset.stickyInit = '';
    initStickyAtc();
  });
})();
